module.exports = __webpack_public_path__ + "img/menu1.2be02941.svg";